// @ts-check
/**
 * @file PushPermissionPrompt.jsx
 * @location src/components/push/PushPermissionPrompt.jsx
 * @role 첫 업무 액션 후 1초 뒤 표시되는 권한 요청 모달.
 *
 *  「업무가 도착하면 바로 알 수 있도록 알림을 켜시겠습니까?」
 *  - 「켜기」    → onEnable() → push.requestAndSubscribe
 *  - 「나중에」  → onDismiss() → uiPrefs.pushPromptDismissedAt 저장 (영구 비-재표시)
 *
 *  외부 채널 X — 온점 앱 자체 push 만(razor 부합).
 */

import { QUIET_HOURS_LABEL } from '../../utils/quietHours.js';

/**
 * @param {{
 *   open: boolean,
 *   onEnable: () => void,
 *   onDismiss: () => void,
 * }} props
 */
export function PushPermissionPrompt({ open, onEnable, onDismiss }) {
  if (!open) return null;
  return (
    <div className="push-prompt-overlay" role="dialog" aria-modal="true">
      <div className="push-prompt">
        <h3>업무가 도착하면 바로 알 수 있도록</h3>
        <p>새 업무 할당과 완료 알림만 보내드립니다. 마케팅·홍보 알림은 보내지 않습니다.</p>
        <p style={{ fontSize: 11, color: 'var(--t3)', marginTop: -4, lineHeight: 1.6 }}>방해금지 시간({QUIET_HOURS_LABEL})에는 알림이 가지 않습니다.</p>
        <div className="push-prompt-actions">
          <button type="button" className="push-prompt-secondary" onClick={onDismiss}>
            나중에
          </button>
          <button type="button" className="push-prompt-primary" onClick={onEnable}>
            켜기
          </button>
        </div>
      </div>
    </div>
  );
}
